<template>
    <az-container>
        <az-form>
            <div class="li-tabela">
                <v-data-table :headers="colunas" :items="itens"
                              :total-items="totalItens"
                              :pagination.sync="paginacaoInterna" :loading="false"
                              no-data-text="Nenhuma comissão encontrada"
                              class="az-table-list tabela-comissao" hide-actions>
                    <template slot="items" slot-scope="props">
                        <td>{{ props.item.descricao }}</td>
                        <td>{{ props.item.sigla }}</td>
                        <td>{{ props.item.presidenteNome | textoSemValor }}</td>
                        <td>{{ props.item.situacao === 'ATIVO' ? 'Ativo' : 'Inativo' }}</td>
                        <td class="table-actions">
                            <v-tooltip top class="no-mobile" v-az-auth="'Comissao.Visualizar'">
                                <a slot="activator" @click="$emit('visualizar',props.item.id)">
                                    <v-icon>search</v-icon>
                                </a>
                                Visualizar
                            </v-tooltip>
                            <v-tooltip v-if="exibirBtnEdicao" top class="no-mobile" v-az-auth="'Comissao.Atualizar'">
                                <a slot="activator" @click="$emit('editar',props.item.id)">
                                    <v-icon>edit</v-icon>
                                </a>
                                Editar
                            </v-tooltip>
                        </td>
                    </template>
                </v-data-table>
              <div class="az-pagination">
                <v-pagination v-if="paginas > 1" v-model="paginacaoInterna.page" :length="paginas"/>
                <v-spacer v-if="paginas <= 1"/>
                <div class="az-select-pagination">
                  <span>Linhas por página:</span>
                  <v-select :items="linhasPorPagina" v-model="paginacaoInterna.rowsPerPage"/>
                </div>
              </div>
            </div>
        </az-form>
    </az-container>
</template>

<script>
    export default {
        name: 'ComissaoBuscaTabela',
        props: ['itens', 'paginacao', 'paginas', 'totalItens', 'exibirBtnEdicao'],
        data() {
            return {
                paginacaoInterna: this.paginacao,
                linhasPorPagina: [10, 25, 50, 100],
                colunas: [
                    {
                        text: 'Nome',
                        align: 'left',
                        sortable: false,
                        class: 'primary--text'
                    },
                    {
                        text: 'Sigla',
                        align: 'left',
                        sortable: false,
                        width: '100px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Pregoeiro',
                        sortable: false,
                        align: 'left',
                        class: 'primary--text'
                    },
                    {
                        text: 'Situação',
                        sortable: false,
                        align: 'left',
                        class: 'primary--text'
                    },
                    {
                        text: 'Ações',
                        sortable: false,
                        align: 'center',
                        width: '10%',
                        class: 'primary--text'
                    }
                ]
            }
        },
        watch: {
            paginacaoInterna: {
                  handler(novoValor) {
                        this.$emit('paginar', novoValor)
                  },
                  deep: true
            }
        }
    }
</script>

<style lang="stylus">
    .az-comissoes
        align-items center

    .az-container .az-table-list tbody tr td a
        color #d28a2C

    .tabela-comissao tbody tr td
        padding 0 10px !important

    @media (max-width: 720px)
        .tabela-comissao
            td:nth-of-type(1):before
                content: "Nome:"

            td:nth-of-type(2):before
                content: "Sigla:"

            td:nth-of-type(3):before
                content: "Pregoeiro:"

            td:nth-of-type(4):before
                content: "Situação:"

            .table-actions
                display none !important
</style>
